(() => {
  const applyVedicaSiteFixes = (root = document) => {
    root.querySelectorAll?.('.m-product-dynamic-checkout').forEach((node) => node.remove());

    root.querySelectorAll?.('.m-product-form .m-add-to-cart.m-button--secondary').forEach((button) => {
      button.classList.remove('m-button--secondary');
      button.classList.add('m-button--primary');
    });

    const refundIntro = root.querySelector?.('.vpc[data-policy="refund"] .vpc__hero-copy');
    if (refundIntro && /COD/i.test(refundIntro.textContent || '')) {
      refundIntro.textContent = 'Refund eligibility, settlement timelines, duplicate payments and payment discrepancies in one place.';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyVedicaSiteFixes(document));
  } else {
    applyVedicaSiteFixes(document);
  }

  document.addEventListener('shopify:section:load', (event) => applyVedicaSiteFixes(event.target));
})();
